import React from 'react';
import { resolveIcon } from '../../core/navigation';
import { CyzorAppManifest } from '../../core/navigation/appRegistry';

interface ComingSoonPageProps {
  manifest: CyzorAppManifest;
}

export function ComingSoonPage({ manifest }: ComingSoonPageProps) {
  const Icon = resolveIcon(manifest.icon);

  return (
    <div className="w-full min-h-full bg-[#F8FAFC] dark:bg-[#0F172A] font-sans">
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <nav aria-label="breadcrumb" className="mb-8">
          <ol className="flex items-center space-x-2 text-sm">
            <li>
              <span className="text-slate-400 dark:text-slate-500">Home</span>
            </li>
            <li className="text-slate-400 dark:text-slate-500">/</li>
            <li>
              <span className="text-slate-600 dark:text-slate-300 font-medium">{manifest.name}</span>
            </li>
          </ol>
        </nav>

        <div className="flex items-center gap-4 mb-8">
          <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center">
            {Icon ? (
              React.createElement(Icon, { size: 28, className: "text-indigo-600 dark:text-indigo-400" })
            ) : (
              <span className="text-2xl">📦</span>
            )}
          </div>
          <div>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white">{manifest.name}</h1>
            <p className="text-slate-500 dark:text-slate-400 mt-1">{manifest.description}</p>
          </div>
        </div>

        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-2xl p-8 text-center">
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center">
              <svg
                className="w-6 h-6 text-indigo-600 dark:text-indigo-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 6v6l4 2"
                />
              </svg>
            </div>
            <div>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300 border border-amber-200 dark:border-amber-800">
                Em desenvolvimento
              </span>
            </div>
            <div className="max-w-md">
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                Este módulo está sendo preparado para o ecossistema CYZOR.
              </p>
            </div>
          </div>
        </div>

        {manifest.capabilities && manifest.capabilities.length > 0 && (
          <div className="mt-8">
            <h3 className="text-sm font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-4">
              Capacidades previstas
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {manifest.capabilities.map((cap) => (
                <li
                  key={cap}
                  className="flex items-center gap-3 p-3 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700"
                >
                  <div className="w-2 h-2 rounded-full bg-slate-300 dark:bg-slate-600 flex-shrink-0" />
                  <span className="text-sm text-slate-700 dark:text-slate-300">{cap}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
